import React, { useState, useContext, useEffect, useRef } from "react";
import Header from "../../Components/HeaderAdmin/Header";
import "../../assets/css/responsive.css";
import { FaPlay } from "react-icons/fa";
import { Form } from "react-bootstrap";
import VideoUpload from "../DashboardComponents/Video/VideoUpload";
import VideoUpload2 from "../DashboardComponents/Video/VideoUpload2";
import IronsData from "../DashboardComponents/IronsData/IronsDatacamera";
import ImageUpload from "../DashboardComponents/ImageUpload/ImageUploadcamera";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Accordion } from "react-bootstrap";
import { FaAngleUp } from "react-icons/fa";
import { ForwardFittingContext } from "./ForwardFittingContext";
import { createremotefittingcamera } from "../../Api/contact";
import { getErrorByField, updateUserremotefitting, addUser } from "../../Api/auth";
import Spinner from 'react-bootstrap/Spinner';
import { useLocation, useHistory } from 'react-router-dom';
import { getUserById } from "../../Api/iron";
import Modal from 'react-bootstrap/Modal';
import { IoClose } from "react-icons/io5";
import { useParams } from "react-router-dom";
import { ReactNotifications, Store } from 'react-notifications-component'
import { getCurrentUser } from "../../Api/auth";

import  "../Cemara/CustomModal.css";
 

function ForewardFitting4() {

    const { remotefittingdata, setRemotefittingdata, updateremotefitting, updateremotefittingfile, remotefittingimage, setRemotefittingimage } = useContext(ForwardFittingContext);

    const [activeEyes, setActiveEyes] = useState({
        step1: { iron1: true, iron2: false, iron3: false },
        step2: { iron1: false, iron2: false, iron3: false },
        step3: { iron1: false, iron2: false, iron3: false },
        step4: { iron1: false, iron2: false, iron3: false },
        step5: { iron1: false, iron2: false, iron3: false },
        step6: { iron1: false, iron2: false, iron3: false },
        step7: { iron1: false, iron2: false, iron3: false },
        step8: { iron1: false, iron2: false, iron3: false },

    });

    useEffect(() => {
        const newActiveEyes = { ...activeEyes };

        for (let i = 1; i <= 8; i++) {
            const step = `step${i}`;
            ['iron1', 'iron2', 'iron3'].forEach(iron => {
                if (iron === 'iron1') {
                    newActiveEyes[step][iron] = true;
                }

                if (iron === 'iron2') {

                    if (remotefittingdata?.[step]?.['iron1']?.shot1?.optionx &&
                        remotefittingdata?.[step]?.['iron1']?.shot1?.optiony &&
                        remotefittingdata?.[step]?.['iron1']?.shot1?.option1 &&
                        remotefittingdata?.[step]?.['iron1']?.shot1?.option2 &&
                        remotefittingdata?.[step]?.['iron1']?.shot2?.optionx &&
                        remotefittingdata?.[step]?.['iron1']?.shot2?.optiony &&
                        remotefittingdata?.[step]?.['iron1']?.shot2?.option1 &&
                        remotefittingdata?.[step]?.['iron1']?.shot2?.option2 &&
                        remotefittingdata?.[step]?.['iron1']?.shot3?.optionx &&
                        remotefittingdata?.[step]?.['iron1']?.shot3?.optiony &&
                        remotefittingdata?.[step]?.['iron1']?.shot3?.option1 &&
                        remotefittingdata?.[step]?.['iron1']?.shot3?.option2) {

                        newActiveEyes[step][iron] = true;
                    }

                }

                if (iron === 'iron3') {
                    if (remotefittingdata?.[step]?.['iron2']?.shot1?.optionx &&
                        remotefittingdata?.[step]?.['iron2']?.shot1?.optiony &&
                        remotefittingdata?.[step]?.['iron2']?.shot1?.option1 &&
                        remotefittingdata?.[step]?.['iron2']?.shot1?.option2 &&
                        remotefittingdata?.[step]?.['iron2']?.shot2?.optionx &&
                        remotefittingdata?.[step]?.['iron2']?.shot2?.optiony &&
                        remotefittingdata?.[step]?.['iron2']?.shot2?.option1 &&
                        remotefittingdata?.[step]?.['iron2']?.shot2?.option2 &&
                        remotefittingdata?.[step]?.['iron2']?.shot3?.optionx &&
                        remotefittingdata?.[step]?.['iron2']?.shot3?.optiony &&
                        remotefittingdata?.[step]?.['iron2']?.shot3?.option1 &&
                        remotefittingdata?.[step]?.['iron2']?.shot3?.option2) {

                        newActiveEyes[step][iron] = true;
                    }
                }
            });
        }

        setActiveEyes(newActiveEyes);
    }, [remotefittingdata]);

    const [validated2, setValidated2] = useState(false);
    const [validated3, setValidated3] = useState(false);
    const [validated4, setValidated4] = useState(false);
    const [validated5, setValidated5] = useState(false);
    const [validated6, setValidated6] = useState(false);
    const [validated7, setValidated7] = useState(false);
    const [validated8, setValidated8] = useState(false);
    const [validated9, setValidated9] = useState(false);

    const formRef = useRef(null);
    const formRef2 = useRef(null);
    const formRef3 = useRef(null);
    const formRef4 = useRef(null);
    const formRef5 = useRef(null);
    const formRef6 = useRef(null);
    const formRef7 = useRef(null);
    const formRef8 = useRef(null);
    const formRef9 = useRef(null);
    const [errors, setErrors] = useState([]);
    const [validated, setValidated] = useState(false);
    const [apicall, setApicall] = useState(false);

    const params = useParams();

    const [apicalldata, setApicalldata] = useState(false);

    const [edittrue, setEdittrue] = useState(true);

    const [userid, setUserid] = useState(0);
    const location = useLocation();
    const history = useHistory();
    console.log("location", location);
    const queryParams = new URLSearchParams(location.search);
    const square_id = queryParams.get('userid');
    const [user_id, setuser_id] = useState(0);
    const [userdata, setUserdata] = useState('');

    const [show02, setShow02] = useState(false);

    const handleClose02 = () => setShow02(false);
    const handleShow02 = () => setShow02(true);

    const [show03, setShow03] = useState(false);

    const handleClose03 = () => setShow03(false);
    const handleShow03 = () => setShow03(true);

    const step2iron1Ref = useRef();
    const step2iron2Ref = useRef();
    const step2iron3Ref = useRef();

    const step3iron1Ref = useRef();
    const step3iron2Ref = useRef();
    const step3iron3Ref = useRef();

    const step4iron1Ref = useRef();
    const step4iron2Ref = useRef();
    const step4iron3Ref = useRef();

    const step5iron1Ref = useRef();
    const step5iron2Ref = useRef();
    const step5iron3Ref = useRef();

    const step6iron1Ref = useRef();
    const step6iron2Ref = useRef();
    const step6iron3Ref = useRef();

    const step7iron1Ref = useRef();
    const step7iron2Ref = useRef();
    const step7iron3Ref = useRef();

    const step8iron1Ref = useRef();
    const step8iron2Ref = useRef();
    const step8iron3Ref = useRef();

    const step9iron1Ref = useRef();
    const step9iron2Ref = useRef();
    const step9iron3Ref = useRef();





    const handleedittrue = () => {
        setEdittrue(!edittrue);
    }

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = ''; // Required for Chrome
            // Custom messages are ignored in most modern browsers
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        const currentUrl = new URL(window.location);
        if (currentUrl.searchParams.has('userid')) {
            currentUrl.searchParams.delete('userid');
            window.history.replaceState(null, '', currentUrl.pathname + currentUrl.search);
        }

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };


        
    }, []);

    useEffect(() => {
    }, [remotefittingdata, remotefittingimage]);

    const [formData, setFormData] = useState({
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        height_ft: "",
        height_in: "",
        wrist_to_floor: "",
        shoulder_to_wrist: "",
        elbow_to_wrist: "",
        dexterity: ""
    });

    useEffect(() => {
        getUserById({ _id: params.id }).then((res) => {
            console.log("res", res);
            if (res?.code === 200) {
                setFormData(res.data.data);
                setuser_id(res.data.data._id)
                setRemotefittingdata({ ...remotefittingdata, step0: { ...remotefittingdata.step0, firstname: res.data.data.firstname } });
                setRemotefittingdata({ ...remotefittingdata, step0: { ...remotefittingdata.step0, lastname: res.data.data.lastname } });
                setRemotefittingdata({ ...remotefittingdata, step0: { ...remotefittingdata.step0, email: res.data.data.email } });
                setRemotefittingdata({ ...remotefittingdata, step0: { ...remotefittingdata.step0, phone: res.data.data.phone } });
                setRemotefittingdata({ ...remotefittingdata, step0: { ...remotefittingdata.step0, height_ft: res.data.data.height_ft } });
                setRemotefittingdata({ ...remotefittingdata, step0: { ...remotefittingdata.step0, height_in: res.data.data.height_in } });
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }, [params]);

    const [firstvideo, setFirstVideo] = useState(null);
    const [secondvideo, setSecondVideo] = useState(null);

    const dataChange = (e) => {
        const { name, value } = e.target;
        setRemotefittingdata({ ...remotefittingdata, step0: { ...remotefittingdata.step0, [name]: value } });
        setFormData({ ...formData, [name]: value });
    }

    const handleUpdateSubmit = async (event) => {
        event.preventDefault();
        console.log("event", event);
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }

        setValidated(true);
    }

    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();
        // setUserdata(getCurrentUserdata.user);
        // setUser_id(getCurrentUserdata.user._id);


        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUserdata(getCurrentUserdata.user);
        } else {
            console.error("Current user data is null or undefined");
        }

    }, []);
    // const options1 = [
    //     { id: 1, text: 'Pull Hook' },
    //     { id: 2, text: 'Pull Straight' },
    //     { id: 3, text: 'Pull Fade' },
    //     { id: 4, text: 'Straight' },
    //     { id: 5, text: 'Push Draw' },
    //     { id: 6, text: 'Push Strait' },
    //     { id: 7, text: 'Push Slice' },
    // ];

    const options1 = [
        { id: 1, text: 'Push Draw' },
        { id: 1, text: 'Pull Fade' },
        { id: 2, text: 'Straight' },
        { id: 3, text: 'Pull Straight' },
        { id: 3, text: 'Push Straight' },
        { id: 4, text: 'Pull Draw' },
        { id: 4, text: 'Push Fade' },
        { id: 5, text: 'Pull Hook' },
        { id: 5, text: 'Push Slice' },
        { id: 8, text: 'Miss Hit' },
    ];

    const options2 = [
        { id: 1, text: 'Push Draw' },
        { id: 1, text: 'Pull Fade' },
        { id: 2, text: 'Straight' },
        { id: 3, text: 'Pull Straight' },
        { id: 3, text: 'Push Straight' },
        { id: 4, text: 'Pull Draw' },
        { id: 4, text: 'Push Fade' },
        { id: 5, text: 'Pull Hook' },
        { id: 5, text: 'Push Slice' },
        { id: 8, text: 'Miss Hit' },
    ];

    const options3 = [
        { id: 1, text: 'Push Draw' },
        { id: 1, text: 'Pull Fade' },
        { id: 2, text: 'Straight' },
        { id: 3, text: 'Pull Straight' },
        { id: 3, text: 'Push Straight' },
        { id: 4, text: 'Pull Draw' },
        { id: 4, text: 'Push Fade' },
        { id: 5, text: 'Pull Hook' },
        { id: 5, text: 'Push Slice' },
        { id: 8, text: 'Miss Hit' },
    ];

    const options4 = [
        { id: 1, text: '1' },
        { id: 2, text: '2' },
        { id: 3, text: '3' },
        { id: 4, text: '4' },
        { id: 5, text: '5' },
    ];

    const shotOpction = [
        { id: 1, text: 'On Target' },
        { id: 2, text: 'Left Of Target' },
        { id: 2, text: 'Right Of Target' },
        { id: 8, text: 'Chunk / Skull' },
    ]

    const shortStrike = [
        { id: 1, text: 'Tiger Strike' },
        { id: 2, text: 'No Tiger Strike' },
    ]

    const [currentStep, setCurrentStep] = useState(1);
    const [CheckcurrentStep, setCheckcurrentStep] = useState(0);

    const [showImageError, setShowImageError] = useState(false);

    const handleNextStep = (event) => {

        if (currentStep == 1) {
            const videofirst = remotefittingimage.step0.swing1;
            const videosecond = remotefittingimage.step0.swing2;
            if (videofirst && videosecond) {
                updateuserdata().then(validated => {
                    if (validated) {
                        setCurrentStep(currentStep + 1);
                        setCheckcurrentStep(CheckcurrentStep + 1);
                        // window.scrollTo(0, 0);
                        setTimeout(() => {
                            window.scrollTo(0, 0);
                        }, 100);
                    }
                });


            } else {
                // Store.addNotification({
                //     title: "Error",
                //     message: "Please upload video",
                //     type: "danger",
                //     insert: "top",
                //     container: "top-right",
                //     animationIn: ["animated", "fadeIn"],
                //     animationOut: ["animated", "fadeOut"],
                //     dismiss: {
                //         duration: 3000,
                //         onScreen: true
                //     }
                // });
                handleShow03();
                // window.scrollTo(0, 0);
                setCurrentStep(1);
                setCheckcurrentStep(0);
                setShowImageError(true);
            }
        }

        if (currentStep == 2) {

            const whitepreferredclub = remotefittingdata.step1.preferred_club;
            const imagefirst = remotefittingimage.step1.iron1.cameraimage;
            const imagesecond = remotefittingimage.step1.iron2.cameraimage;
            const imagethird = remotefittingimage.step1.iron3.cameraimage;


            if (!imagefirst || !imagesecond || !imagethird) {
                handleShow03();
                setShowImageError(true);
            } else {
                if (whitepreferredclub === "") {
                    handleShow03();
                } else {
                    setCurrentStep(currentStep + 1);
                    setCheckcurrentStep(CheckcurrentStep + 1);
                    //setValidated2(true);
                    window.scrollTo(0, 0);
                }
            }
            setValidated2(true);
        }

        if (currentStep == 3) {

            const blackpreferredclub = remotefittingdata.step2.preferred_club;
            const step2imagefirst = remotefittingimage.step2.iron1.cameraimage;
            const step2imagesecond = remotefittingimage.step2.iron2.cameraimage;
            const step2imagethird = remotefittingimage.step2.iron3.cameraimage;

            if (!step2imagefirst || !step2imagesecond || !step2imagethird) {
                handleShow03();
                setShowImageError(true);
            } else {
                if (blackpreferredclub === "") {
                    handleShow03();
                } else {
                    setCurrentStep(currentStep + 1);
                    setCheckcurrentStep(CheckcurrentStep + 1);
                    window.scrollTo(0, 0);
                }
            }
            setValidated3(true);
        }

        if (currentStep == 4) {

            const Bluepreferredclub = remotefittingdata.step3.preferred_club;
            const step3imagefirst = remotefittingimage.step3.iron1.cameraimage;
            const step3imagesecond = remotefittingimage.step3.iron2.cameraimage;
            const step3imagethird = remotefittingimage.step3.iron3.cameraimage;

            if (!step3imagefirst || !step3imagesecond || !step3imagethird) {
                handleShow03();
                setShowImageError(true);
            } else {
                if (Bluepreferredclub === "") {
                    handleShow03();
                } else {
                    setCurrentStep(currentStep + 1);
                    setCheckcurrentStep(CheckcurrentStep + 1);
                    window.scrollTo(0, 0);
                }

            }
            setValidated4(true);
        }

        if (currentStep == 5) {

            const Pinkpreferredclub = remotefittingdata.step4.preferred_club;
            const step4imagefirst = remotefittingimage.step4.iron1.cameraimage;
            const step4imagesecond = remotefittingimage.step4.iron2.cameraimage;
            const step4imagethird = remotefittingimage.step4.iron3.cameraimage;

            if (!step4imagefirst || !step4imagesecond || !step4imagethird) {
                handleShow03();
                setShowImageError(true);
            } else {
                if (Pinkpreferredclub === "") {
                    handleShow03();
                } else {
                    setCurrentStep(currentStep + 1);
                    setCheckcurrentStep(CheckcurrentStep + 1);
                    window.scrollTo(0, 0);
                }
            }
            setValidated5(true);
        }

        if (currentStep == 6) {

            const Purplepreferredclub = remotefittingdata.step5.preferred_club;
            const step5imagefirst = remotefittingimage.step5.iron1.cameraimage;
            const step5imagesecond = remotefittingimage.step5.iron2.cameraimage;
            const step5imagethird = remotefittingimage.step5.iron3.cameraimage;

            if (!step5imagefirst || !step5imagesecond || !step5imagethird) {
                setShowImageError(true);
                handleShow03();
            } else {
                if (Purplepreferredclub === "") {
                    handleShow03();
                } else {
                    setCurrentStep(currentStep + 1);
                    setCheckcurrentStep(CheckcurrentStep + 1);
                    window.scrollTo(0, 0);
                }
            }
            setValidated6(true);
        }

        if (currentStep == 7) {

            const Redpreferredclub = remotefittingdata.step6.preferred_club;
            const step6imagefirst = remotefittingimage.step6.iron1.cameraimage;
            const step6imagesecond = remotefittingimage.step6.iron2.cameraimage;
            const step6imagethird = remotefittingimage.step6.iron3.cameraimage;

            if (!step6imagefirst || !step6imagesecond || !step6imagethird) {
                setShowImageError(true);
                handleShow03();
            } else {
                if (Redpreferredclub === "") {
                    handleShow03();
                } else {
                    setCurrentStep(currentStep + 1);
                    setCheckcurrentStep(CheckcurrentStep + 1);
                    window.scrollTo(0, 0);
                }

            }
            setValidated7(true);
        }

        if (currentStep == 8) {

            const Orangepreferredclub = remotefittingdata.step7.preferred_club;
            const step7imagefirst = remotefittingimage.step7.iron1.cameraimage;
            const step7imagesecond = remotefittingimage.step7.iron2.cameraimage;
            const step7imagethird = remotefittingimage.step7.iron3.cameraimage;

            if (!step7imagefirst || !step7imagesecond || !step7imagethird) {
                setShowImageError(true);
                handleShow03();
            } else {
                if (Orangepreferredclub === "") {
                    handleShow03();
                } else {
                    setCurrentStep(currentStep + 1);
                    setCheckcurrentStep(CheckcurrentStep + 1);
                    window.scrollTo(0, 0);
                }
            }
            setValidated8(true);
        }

        if (currentStep == 9) {

            const Greenpreferredclub = remotefittingdata.step8.preferred_club;
            const step8imagefirst = remotefittingimage.step8.iron1.cameraimage;
            const step8imagesecond = remotefittingimage.step8.iron2.cameraimage;
            const step8imagethird = remotefittingimage.step8.iron3.cameraimage;


            if (!step8imagefirst || !step8imagesecond || !step8imagethird) {
                setShowImageError(true);
                handleShow03();
            } else {
                // if(Greenpreferredclub){
                //     handleShow03();
                // }else{
                const notes = remotefittingdata.step8.notes;
                setCurrentStep(currentStep + 1);
                setCheckcurrentStep(CheckcurrentStep + 1);
                window.scrollTo(0, 0);
                // }

            }
            setValidated9(true);
        }
    };

    const handlePrevStep = () => {
        setCurrentStep(currentStep - 1);
        window.scrollTo(0, 0);
    };

    const renderStepContent = () => {
        switch (currentStep) {
            case 1:
                return (
                    <div className="step-content-item step-content-item-active w-100 step-1">
                        <div className="step">
                            <div class="sec-header-dash">
                                <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                    <h3>Getting Started</h3>
                                </div>
                            </div>
                            <div class="dashboard-sec">
                                <div className="bg_color_sec">
                                    <div className="row align-items-center mb-5">
                                        <div className="col-md-6">
                                            <div class="box-step-content admin-box">
                                                <div class="box-title">
                                                    <h4>Watch this to get started</h4>
                                                </div>
                                                <div class="box-text">
                                                    <p>Before you start watch the videos below to get grasp on what you will be doing and how the process works.</p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="col-md-6">
                                            <div class="box-step-img">
                                                <img src={require('../../assets/images/bg-img.png')} alt="img" />
                                                <div className="play_icon">
                                                    <div className="play_icon_item">
                                                        <FaPlay />
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>
                                    <div>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <div eventKey="0" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <div>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>What we will be doing here</h5>
                                                                    </div>
                                                                    <div className="">
                                                                        <div className="barplay_icon_item">
                                                                            <FaPlay size={15} color="#ffffff" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>To edit your info use the form below to update any info that is incorrect. Press save once its corrected.</p>
                                                            </div>
                                                        </Accordion.Body> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <div eventKey="1" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <div>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>Launch monitor data setup</h5>
                                                                    </div>
                                                                    <div className="">
                                                                        <div className="barplay_icon_item">
                                                                            <FaPlay size={15} color="#ffffff" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>Save and export your session data during the fitting. When we reach out afterwards we will get it via email.</p>
                                                            </div>
                                                        </Accordion.Body> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <div eventKey="2" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <div>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>Who to contact for help</h5>
                                                                    </div>
                                                                    <div className="">
                                                                        <div className="barplay_icon_item">
                                                                            <FaPlay size={15} color="#ffffff" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>If you have any issues during the fitting email us at info@foreward.golf and we will give you a call back.</p>
                                                            </div>
                                                        </Accordion.Body> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="sec-header-dash">
                                <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                    <h3>Your Info</h3>
                                </div>
                                {/* <div class="content-box-btn">
                                    <button class="btn btn-add" onClick={handleedittrue}> {userid == 0 ? "Add" : "Edit"} </button>
                                </div> */}
                            </div>
                            <Form noValidate ref={formRef} validated={validated} onSubmit={handleUpdateSubmit}>
                                <div className="dashboard-sec">
                                    <div className="container-fulid">
                                        <fieldset>
                                            <div className="form-box-section mt-4">
                                                <div className="form-box-inner">
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Name</label>
                                                            <div className="w-100 me-2">
                                                                <input type="text"
                                                                    required
                                                                    className="form-control dashboard-input-box-3"
                                                                    // placeholder="Name"
                                                                    disabled={true}
                                                                    value={formData.firstname}
                                                                    name={"firstname"}
                                                                    onChange={(e) => dataChange(e)}
                                                                />
                                                                <Form.Control.Feedback type="invalid">
                                                                    {
                                                                        errors.length > 0 ? getErrorByField(errors, "firstname").map((item) => {
                                                                            return item.detail;
                                                                        }) : "Please enter valid firstname"
                                                                    }
                                                                </Form.Control.Feedback>
                                                            </div>
                                                            <div className="w-100">
                                                                <input type="text"
                                                                    required
                                                                    className="form-control dashboard-input-box-3 me-1"
                                                                    // placeholder="Last"
                                                                    disabled={true}
                                                                    name={"lastname"}
                                                                    // disabled={!edittrue}
                                                                    value={formData.lastname}
                                                                    onChange={(e) => dataChange(e)}
                                                                />
                                                                <Form.Control.Feedback type="invalid">
                                                                    {
                                                                        errors.length > 0 ? getErrorByField(errors, "lastname").map((item) => {
                                                                            return item.detail;
                                                                        }) : "Please enter valid firstname"
                                                                    }
                                                                </Form.Control.Feedback>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <Form.Label className="dashboard-form-lable">Email</Form.Label>
                                                            <div className="w-100">
                                                                <Form.Control
                                                                    type="email"
                                                                    // placeholder="Email Address"
                                                                    name="email"
                                                                    disabled={true}
                                                                    required
                                                                    className={`form-control dashboard-input-box-3 ${getErrorByField(errors, 'email').length > 0 ? 'is-invalid' : ''}`}
                                                                    // disabled={!edittrue}
                                                                    value={formData.email}
                                                                    onChange={(e) => dataChange(e)}
                                                                />
                                                                <Form.Control.Feedback type="invalid">
                                                                    {
                                                                        errors.length > 0 ? getErrorByField(errors, "email").map((item) => {
                                                                            return item.detail;
                                                                        }) : "Please enter valid email"
                                                                    }
                                                                </Form.Control.Feedback>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group mb-0">
                                                            <label className="dashboard-form-lable">Phone</label>
                                                            <div className="w-100">
                                                                <input type="number"
                                                                    name={"phone"}
                                                                    // placeholder="Phone Number"
                                                                    required
                                                                    // disabled={!edittrue}
                                                                    disabled={true}
                                                                    className={`form-control dashboard-input-box-3 ${getErrorByField(errors, 'phone_number').length > 0 ? 'is-invalid' : ''}`}
                                                                    value={formData.phone}
                                                                    onChange={(e) => dataChange(e)} />
                                                                <Form.Control.Feedback type="invalid">
                                                                    {
                                                                        errors.length > 0 ? getErrorByField(errors, "phone_number").map((item) => {
                                                                            return item.detail;
                                                                        }) : "Please enter valid phone number"
                                                                    }
                                                                </Form.Control.Feedback>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                                <div class="sec-header-dash">
                                    <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                        <h3>Your Height</h3>
                                    </div>
                                </div>
                                <div class="dashboard-sec">
                                    <div className="form-box-section mt-4">
                                        <div className="form-item height-form-iteam">
                                            <div className="form-group custom-form-group mb-0">
                                                <label className="dashboard-form-lable">Height</label>
                                                <div className="d-flex justify-content-end gap-2 align-items-center w-100">
                                                    {/* <input type="number" required className="form-control dashboard-input-box w-30" placeholder="0" disabled={!edittrue} name={"height_ft"} value={formData.height_ft} onChange={(e) => dataChange(e)} />
                                                    <label className="dashboard-form-lable me-0">ft.</label>
                                                    <input type="number" required className="form-control dashboard-input-box w-30" placeholder="0" disabled={!edittrue} name={"height_in"} value={formData.height_in} onChange={(e) => dataChange(e)} />
                                                    <label className="dashboard-form-lable me-0">in.</label> */}
                                                    <select
                                                        required
                                                        className="form-select form-control dashboard-input-box-3 select-custom-boxx w-25"
                                                        disabled={!edittrue}
                                                        name="height_ft"
                                                        value={formData.height_ft}
                                                        onChange={(e) => dataChange(e)}
                                                        aria-label="Default select example"
                                                    >
                                                        <option value="" disabled>
                                                            ft.
                                                        </option>
                                                        <option value="4">4 ft.</option>
                                                        <option value="5">5 ft.</option>
                                                        <option value="6">6 ft.</option>
                                                        <option value="7">7 ft.</option>
                                                    </select>
                                                    <select
                                                        required
                                                        class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25"
                                                        disabled={!edittrue} name={"height_in"}
                                                        value={formData.height_in}
                                                        onChange={(e) => dataChange(e)}
                                                        aria-label="Default select example"
                                                    >
                                                        <option value='' disabled>
                                                            in.
                                                        </option>
                                                        <option value="1">0 in.</option>
                                                        <option value="2">1 in.</option>
                                                        <option value="3">2 in.</option>
                                                        <option value="4">3 in.</option>
                                                        <option value="5">4 in.</option>
                                                        <option value="6">5 in.</option>
                                                        <option value="7">6 in.</option>
                                                        <option value="8">7 in.</option>
                                                        <option value="9">8 in.</option>
                                                        <option value="10">9 in.</option>
                                                        <option value="11">10 in.</option>
                                                        <option value="12">11 in.</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="sec-header-dash">
                                    <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                        <h3>Your Dexterity</h3>
                                    </div>
                                </div>
                                <div class="dashboard-sec">
                                    <div className="form-box-section mt-4">
                                        <div className="form-item height-form-iteam">
                                            <div className="form-group custom-form-group mb-0">
                                                <label className="dashboard-form-lable">Dexterity</label>
                                                <div className="d-flex justify-content-end gap-2 align-items-center w-100">
                                                    {/* <input type="number" required className="form-control dashboard-input-box w-30" placeholder="0" disabled={!edittrue} name={"height_ft"} value={formData.height_ft} onChange={(e) => dataChange(e)} />
                                                    <label className="dashboard-form-lable me-0">ft.</label>
                                                    <input type="number" required className="form-control dashboard-input-box w-30" placeholder="0" disabled={!edittrue} name={"height_in"} value={formData.height_in} onChange={(e) => dataChange(e)} />
                                                    <label className="dashboard-form-lable me-0">in.</label> */}
                                                    <select required class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" disabled={!edittrue} name={"dexterity"} value={formData.dexterity} onChange={(e) => dataChange(e)} aria-label="Default select example">
                                                        <option value='' disabled>
                                                            Dexterity
                                                        </option>
                                                        <option value="1">Right Handed</option>
                                                        <option value="2">Left Handed</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                            <div class="sec-header-dash">
                                <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                    <h3>Your Swing</h3>
                                </div>
                            </div>
                            <div class="dashboard-sec">
                                <div className="bg_color_sec">
                                    <div className="row align-items-center mb-5">
                                        <div className="col-md-6">
                                            <div class="box-step-content admin-box">
                                                <div class="box-title">
                                                    <h4>Film and send your swing</h4>
                                                </div>
                                                <div class="box-text">
                                                    <p>The first thing we need is videos of your swing. Watch the videos below to ensure we are getting the right angles.</p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="col-md-6">
                                            <div class="box-step-img">
                                                <img src={require('../../assets/images/bg-img.png')} alt="img" />
                                                <div className="play_icon">
                                                    <div className="play_icon_item">
                                                        <FaPlay />
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>
                                    <div>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <div eventKey="0" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <div>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>What is the proper angles?</h5>
                                                                    </div>
                                                                    <div className="">
                                                                        <div className="barplay_icon_item">
                                                                            <FaPlay size={15} color="#ffffff" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>Just use your cell phone! We don’t need slo mo videos. Just hold it vertically and film your angles.</p>
                                                            </div>
                                                        </Accordion.Body> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <div eventKey="1" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <div>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>What camera do I use?</h5>
                                                                    </div>
                                                                    <div className="">
                                                                        <div className="barplay_icon_item">
                                                                            <FaPlay size={15} color="#ffffff" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>Please watch the video above for directions. Camera is held at naval height from DTL and FO angles.</p>
                                                            </div>
                                                        </Accordion.Body> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <div eventKey="2" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <div>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>If it’s not your best swing?</h5>
                                                                    </div>
                                                                    <div className="">
                                                                        <div className="barplay_icon_item">
                                                                            <FaPlay size={15} color="#ffffff" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>This isn’t the end of the world. We are looking at face to path ratios. We will see what we need to.</p>
                                                            </div>
                                                        </Accordion.Body> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="dashboard-sec">
                                <div className="bg_color_dark">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="d-flex justify-content-center gap-2">
                                                <VideoUpload
                                                    borderClass={(showImageError && remotefittingimage.step0.swing1 == "") ? "foreward-fitting-video" : "drop_box"}
                                                    step="step0"
                                                    onfilechange={(editfile) => setFirstVideo(editfile)}
                                                />
                                                <VideoUpload2
                                                    borderClass={(showImageError && remotefittingimage.step0.swing2 == "") ? "foreward-fitting-video" : "drop_box"}
                                                    step="step0"
                                                    onfilechange={(editfile) => setSecondVideo(editfile)}

                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="sec-header-dash">
                                <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                    <h3>Component Testing</h3>
                                </div>

                            </div>
                            <div class="dashboard-sec">
                                <div className="bg_color_sec">
                                    <div className="row align-items-center mb-5">
                                        <div className="col-md-6">
                                            <div class="box-step-content admin-box">
                                                <div class="box-title">
                                                    <h4>Let’s start testing clubs</h4>
                                                </div>
                                                <div class="box-text">
                                                    <p>Its time to start testing irons. Watch the videos below to get an overview of how to go through the process.</p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="col-md-6">
                                            <div class="box-step-img">
                                                <img src={require('../../assets/images/bg-img.png')} alt="img" />
                                                <div className="play_icon">
                                                    <div className="play_icon_item">
                                                        <FaPlay />
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>
                                    <div>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <div eventKey="0" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <div>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>Do I need to go in order?</h5>
                                                                    </div>
                                                                    <div className="">
                                                                        <div className="barplay_icon_item">
                                                                            <FaPlay size={15} color="#ffffff" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>Yes. The interface won’t allow you to skip any steps. We designed this process to work in order.</p>
                                                            </div>
                                                        </Accordion.Body> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <div eventKey="1" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <div>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>How to log strike location?</h5>
                                                                    </div>
                                                                    <div className="">
                                                                        <div className="barplay_icon_item">
                                                                            <FaPlay size={15} color="#ffffff" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>Watch the video! We just need all three sprayed clubs of the section laid down and photographed.</p>
                                                            </div>
                                                        </Accordion.Body> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <div eventKey="2" className="mobile-accordion">
                                                    <div className="bg_green_light color_green_bg">
                                                        <div className="gs_fr_tops" id="lesson_card_1">
                                                            <div>
                                                                <div className="gab_title">
                                                                    <div className="gab_text bg-accordion-title">
                                                                        <h5>What is a preferred club?</h5>
                                                                    </div>
                                                                    <div className="">
                                                                        <div className="barplay_icon_item">
                                                                            <FaPlay size={15} color="#ffffff" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <Accordion.Body className="box-accordion-body">
                                                            <div class="box-text admin-box box-accordion-p">
                                                                <p>This is purely subjective. We want to know which option felt the best to you. No data, just feels.</p>
                                                            </div>
                                                        </Accordion.Body> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case 2:
                return (
                    <div className="step-content-item w-100 step-2">
                        <div className="sec-header-dash white">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> White Irons
                                </h3>
                            </div>
                        </div>
                        <Form noValidate ref={formRef2} validated={validated2} onSubmit={handleUpdateSubmit}>
                            <div>


                                <IronsData
                                    ref={step2iron1Ref}
                                    step="step1"
                                    iron="iron1"
                                    title="White Iron"
                                    number={'1'}
                                    options={options1}
                                    shotOpction={shotOpction}
                                    shortStrike={shortStrike}
                                    options2={options4}
                                    activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step1.iron1.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                                <IronsData
                                    ref={step2iron2Ref}
                                    step="step1"
                                    iron="iron2"
                                    title="White Iron"
                                    number={'2'}
                                    options={options2}
                                    shotOpction={shotOpction}
                                    shortStrike={shortStrike}
                                    options2={options4}
                                    activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step1.iron2.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                                <IronsData
                                    ref={step2iron3Ref}
                                    step="step1"
                                    iron="iron3"
                                    title="White Iron"
                                    number={'3'}
                                    options={options3}
                                    shotOpction={shotOpction}
                                    shortStrike={shortStrike}
                                    options2={options4}
                                    activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step1.iron3.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                            </div>
                            <ImageUpload step="step1" title="White" />
                        </Form>
                    </div>
                );
            case 3:
                return (
                    <div className="step-content-item black w-100 step-3">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Black Irons
                                </h3>
                            </div>
                        </div>
                        <Form noValidate ref={formRef3} validated={validated3} onSubmit={handleUpdateSubmit}>
                            <div>
                                <IronsData ref={step3iron1Ref} step="step2" iron="iron1" title="Black Iron" number={'1'} options={options1} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step2.iron1.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                                <IronsData ref={step3iron2Ref} step="step2" iron="iron2" title="Black Iron" number={'2'} options={options2} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step2.iron2.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                                <IronsData ref={step3iron3Ref} step="step2" iron="iron3" title="Black Iron" number={'3'} options={options3} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step2.iron3.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                            </div>
                            <ImageUpload step="step2" title="Black" />
                        </Form>
                    </div>
                );
            case 4:
                return (
                    <div className="step-content-item blue w-100 step-4">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Blue Irons
                                </h3>
                            </div>
                        </div>
                        <Form noValidate ref={formRef4} validated={validated4} onSubmit={handleUpdateSubmit}>
                            <div>
                                <IronsData ref={step4iron1Ref} step="step3" iron="iron1" title="Blue Iron" number={'1'} options={options1} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step3.iron1.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                                <IronsData ref={step4iron2Ref} step="step3" iron="iron2" title="Blue Iron" number={'2'} options={options2} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step3.iron2.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                                <IronsData ref={step4iron3Ref} step="step3" iron="iron3" title="Blue Iron" number={'3'} options={options3} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step3.iron3.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                            </div>
                            <ImageUpload step="step3" title="Blue" />
                        </Form>
                    </div>
                );
            case 5:
                return (
                    <div className="step-content-item pink w-100 step-5">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Pink Irons
                                </h3>
                            </div>

                        </div>
                        <Form noValidate ref={formRef5} validated={validated5} onSubmit={handleUpdateSubmit}>
                            <div>
                                <IronsData ref={step5iron1Ref} step="step4" iron="iron1" title="Pink Iron" number={'1'} options={options1} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step4.iron1.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                                <IronsData ref={step5iron2Ref} step="step4" iron="iron2" title="Pink Iron" number={'2'} options={options2} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step4.iron2.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                                <IronsData ref={step5iron3Ref} step="step4" iron="iron3" title="Pink Iron" number={'3'} options={options3} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step4.iron3.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                            </div>
                            <ImageUpload step="step4" title="Pink" />
                        </Form>
                    </div>
                );
            case 6:
                return (
                    <div className="step-content-item purpal w-100 step-6">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Purple Irons
                                </h3>
                            </div>
                        </div>
                        <Form noValidate ref={formRef6} validated={validated6} onSubmit={handleUpdateSubmit}>
                            <div>
                                <IronsData ref={step6iron1Ref} step="step5" iron="iron1" title="Purple Iron" number={'1'} options={options1} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step5.iron1.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                                <IronsData ref={step6iron2Ref} step="step5" iron="iron2" title="Purple Iron" number={'2'} options={options2} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step5.iron2.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                                <IronsData ref={step6iron3Ref} step="step5" iron="iron3" title="Purple Iron" number={'3'} options={options3} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step5.iron3.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                            </div>
                            <ImageUpload step="step5" title="Purple" />
                        </Form>
                    </div>
                );
            case 7:
                return (
                    <div className="step-content-item red w-100 step-7">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Red Irons
                                </h3>
                            </div>
                        </div>
                        <Form noValidate ref={formRef7} validated={validated7} onSubmit={handleUpdateSubmit}>
                            <div>
                                <IronsData ref={step7iron1Ref} step="step6" iron="iron1" title="Red Iron" number={'1'} options={options1} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step6.iron1.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                                <IronsData ref={step7iron2Ref} step="step6" iron="iron2" title="Red Iron" number={'2'} options={options2} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step6.iron2.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                                <IronsData ref={step7iron3Ref} step="step6" iron="iron3" title="Red Iron" number={'3'} options={options3} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step6.iron3.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                            </div>
                            <ImageUpload step="step6" title="Red" />
                        </Form>
                    </div>
                );
            case 8:
                return (
                    <div className="step-content-item orange w-100 step-8">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Orange Irons
                                </h3>
                            </div>

                        </div>
                        <Form noValidate ref={formRef8} validated={validated8} onSubmit={handleUpdateSubmit}>
                            <div>
                                <IronsData ref={step8iron1Ref} step="step7" iron="iron1" title="Orange Iron" number={'1'} options={options1} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step7.iron1.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                                <IronsData ref={step8iron2Ref} step="step7" iron="iron2" title="Orange Iron" number={'2'} options={options2} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step7.iron2.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                                <IronsData ref={step8iron3Ref} step="step7" iron="iron3" title="Orange Iron" number={'3'} options={options3} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step7.iron3.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                            </div>
                            <ImageUpload step="step7" title="Orange" />
                        </Form>
                    </div>
                );
            case 9:
                return (
                    <div className="step-content-item green w-100 step-8">
                        <div className="sec-header-dash">
                            <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>
                                    <span className="color"></span> Green Irons
                                </h3>
                            </div>

                        </div>
                        <Form noValidate ref={formRef9} validated={validated9} onSubmit={handleUpdateSubmit}>
                            <div>
                                <IronsData ref={step9iron1Ref} step="step8" iron="iron1" title="Green Iron" number={'1'} options={options1} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step8.iron1.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                                <IronsData ref={step9iron2Ref} step="step8" iron="iron2" title="Green Iron" number={'2'} options={options2} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step8.iron2.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                                <IronsData ref={step9iron3Ref} step="step8" iron="iron3" title="Green Iron" number={'3'} options={options3} shotOpction={shotOpction} shortStrike={shortStrike} options2={options4} activeEyes={activeEyes}
                                    borderClass={(showImageError && remotefittingimage.step8.iron3.cameraimage == "") ? "foreward-fitting-video" : "drop_box"}
                                />
                            </div>
                            <ImageUpload step="step8" title="Green" />
                        </Form>
                    </div>
                );
            case 10:
                return (
                    <div className="step-content-item w-100 step-9">
                        <div class="sec-header-dash">
                            <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>Finishing Up</h3>
                            </div>
                        </div>
                        <div class="dashboard-sec">
                            <div className="bg_color_sec">
                                <div className="row align-items-center mb-5">
                                    <div className="col-md-6">
                                        <div class="box-step-content admin-box">
                                            <div class="box-title">
                                                <h4>What happens now?</h4>
                                            </div>
                                            <div class="box-text">
                                                <p>Before you submit your fitting leave us some notes below. Once you submit this our team will be in contact.</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-6">
                                        <div class="box-step-img">
                                            <img src={require('../../assets/images/bg-img.png')} alt="img" />
                                            <div className="play_icon">
                                                <div className="play_icon_item">
                                                    <FaPlay />
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                                <div>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <div eventKey="0" className="mobile-accordion">
                                                <div className="bg_green_light color_green_bg">
                                                    <div className="gs_fr_tops" id="lesson_card_1">
                                                        <div>
                                                            <div className="gab_title">
                                                                <div className="gab_text bg-accordion-title">
                                                                    <h5>What are the notes for?</h5>
                                                                </div>
                                                                <div className="">
                                                                    <div className="barplay_icon_item">
                                                                        <FaPlay size={15} color="#ffffff" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <Accordion.Body className="box-accordion-body">
                                                        <div class="box-text admin-box box-accordion-p">
                                                            <p>We want to understand what you thought and felt during testing. Whatever it is leave it for us!</p>
                                                        </div>
                                                    </Accordion.Body> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <div eventKey="1" className="mobile-accordion">
                                                <div className="bg_green_light color_green_bg">
                                                    <div className="gs_fr_tops" id="lesson_card_1">
                                                        <div>
                                                            <div className="gab_title">
                                                                <div className="gab_text bg-accordion-title">
                                                                    <h5>What happens after this?</h5>
                                                                </div>
                                                                <div className="">
                                                                    <div className="barplay_icon_item">
                                                                        <FaPlay size={15} color="#ffffff" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <Accordion.Body className="box-accordion-body">
                                                        <div class="box-text admin-box box-accordion-p">
                                                            <p>We are going to talk. We will reach our via email to dial you in and get you your prescription.</p>
                                                        </div>
                                                    </Accordion.Body> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <div eventKey="2" className="mobile-accordion">
                                                <div className="bg_green_light color_green_bg">
                                                    <div className="gs_fr_tops" id="lesson_card_1">
                                                        <div>
                                                            <div className="gab_title">
                                                                <div className="gab_text bg-accordion-title">
                                                                    <h5>What will you receive?</h5>
                                                                </div>
                                                                <div className="">
                                                                    <div className="barplay_icon_item">
                                                                        <FaPlay size={15} color="#ffffff" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <Accordion.Body className="box-accordion-body">
                                                        <div class="box-text admin-box box-accordion-p">
                                                            <p>You will get a full prescription of what we would build you. No loyalty to any brand, not even ours.</p>
                                                        </div>
                                                    </Accordion.Body> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sec-header-dash">
                            <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                <h3>Your Notes</h3>
                            </div>
                        </div>

                        <div className="dashboard-sec">
                            <div className="form-box-section mb-3">
                                <textarea className="dashboard-text-area" id="exampleFormControlTextarea1" rows="8" onChange={(e) => { updateremotefitting(`step9.notes`, e.target.value) }} placeholder="Leave your note here..."></textarea>
                            </div>
                        </div>

                        <buton className="btn btn-colr-white active mt-3 mb-3 d-flex justify-content-center align-items-center btn-fitting-submit" onClick={() => updateremotefittingdata()}>{apicalldata ? (<Spinner animation="border" className="border-black" />) : (<span>Submit Your Fitting</span>)}</buton>
                    </div>
                );
            default:
                return null;
        }
    };

    const currentStepName = () => {
        switch (currentStep) {
            case 1:
                return "Get Started";
            case 2:
                return "Get Started";
            case 3:
                return "White Irons";
            case 4:
                return "Black Irons";
            case 5:
                return "Blue Irons";
            case 6:
                return "Pink Irons";
            case 7:
                return "Purple Irons";
            case 8:
                return "Red Irons";
            case 9:
                return "Orange Irons";
            case 10:
                return "Green Irons";

            default:
                return null;
        }
    };

    const nextStepName = () => {
        switch (currentStep + 1) {
            case 2:
                return "White Irons";
            case 3:
                return "Black Irons";
            case 4:
                return "Blue Irons";
            case 5:
                return "Pink Irons";
            case 6:
                return "Purple Irons";
            case 7:
                return "Red Irons";
            case 8:
                return "Orange Irons";
            case 9:
                return "Green Irons";
            case 10:
                return "Finish Up";
            case 11:
                return "Submit Fitting";

            default:
                return null;
        }
    };

    const updateremotefittingdata = () => {

        setApicalldata(true);
        const formData = new FormData();
        formData.append('remotefittingdata', JSON.stringify(remotefittingdata));
        formData.append('email', formData.email);
        formData.append('user_id', params.id);
        formData.append('square_id', square_id);
        formData.append('fitter_id', userdata._id);
        formData.append('fitting_type', "camera");

        // if (remotefittingimage) {
        //     if (remotefittingimage.step0.swing1 instanceof File) {
        //         formData.append('video', remotefittingimage.step0.swing1);
        //     }
        //     if (remotefittingimage.step0.swing2 instanceof File) {
        //         formData.append('video', remotefittingimage.step0.swing2);
        //     }
        //     if (remotefittingimage.step1.location instanceof File) {
        //         formData.append('image', remotefittingimage.step1.iron1.cameraimage);
        //     }
        //     if (remotefittingimage.step2.location instanceof File) {
        //         formData.append('image', remotefittingimage.step2.location);
        //     }
        //     if (remotefittingimage.step3.location instanceof File) {
        //         formData.append('image', remotefittingimage.step3.location);
        //     }
        //     if (remotefittingimage.step4.location instanceof File) {
        //         formData.append('image', remotefittingimage.step4.location);
        //     }
        //     if (remotefittingimage.step5.location instanceof File) {
        //         formData.append('image', remotefittingimage.step5.location);
        //     }
        //     if (remotefittingimage.step6.location instanceof File) {
        //         formData.append('image', remotefittingimage.step6.location);
        //     }
        //     if (remotefittingimage.step7.location instanceof File) {
        //         formData.append('image', remotefittingimage.step7.location);
        //     }
        //     if (remotefittingimage.step8.location instanceof File) {
        //         formData.append('image', remotefittingimage.step8.location);
        //     }
        // }

        if (remotefittingimage) {
            if (remotefittingimage.step0.swing1 instanceof File) {
                formData.append('video', remotefittingimage.step0.swing1);
            }
            if (remotefittingimage.step0.swing2 instanceof File) {
                formData.append('video', remotefittingimage.step0.swing2);
            }
        }

        const imageData = {}; // Object to hold the structured data

        Object.keys(remotefittingimage).forEach((stepKey) => {
            const stepData = {}; // Object to hold iron data for each step

            Object.keys(remotefittingimage[stepKey]).forEach((ironKey) => {
                const cameraImage = remotefittingimage[stepKey][ironKey]?.cameraimage || "";

                // Assigning the camera image for each iron
                stepData[ironKey] = { cameraimage: cameraImage };

                if (cameraImage instanceof File) {
                    formData.append('image', cameraImage);
                } else if (cameraImage.startsWith('data:image/')) {
                    // For base64 image, create Blob and append to formData
                    const base64Data = cameraImage.split(',')[1];
                    const byteString = atob(base64Data);
                    const mimeType = cameraImage.match(/data:(.*?);base64,/)[1];
                    const arrayBuffer = new Uint8Array(byteString.length);

                    for (let i = 0; i < byteString.length; i++) {
                        arrayBuffer[i] = byteString.charCodeAt(i);
                    }

                    const blob = new Blob([arrayBuffer], { type: mimeType });
                    formData.append('image', blob, `${stepKey}_${ironKey}.jpg`);
                }
            });

            // Assign the constructed iron data to the corresponding step
            imageData[stepKey] = stepData;
        });
 

        createremotefittingcamera(formData).then((res) => {
            console.log("res", res);
            if (!res.data.status) {
                setErrors(res.data.data);
                alert(res.data.data[0].detail);
            } else {
                setApicalldata(false);
                handleShow02();

                setTimeout(() => {
                    if (userdata.role_id === 1) {
                        window.location.href = "/fitter-dashboard";
                    } else {
                        window.location.href = "/user-dashboard";
                    }
                }, 2000);
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }

    const addUseruserdata = async () => {
        try {
            setApicall(true);
            const data = {
                email: remotefittingdata.step0.email,
                firstname: remotefittingdata.step0.firstname,
                lastname: remotefittingdata.step0.lastname,
                phone: remotefittingdata.step0.phone,
                height_ft: remotefittingdata.step0.height_ft,
                height_in: remotefittingdata.step0.height_in,
                password: "123456"
            }
            const res = await addUser(data);
            if (!res.data.status) {
                setErrors(res.data.error);
                setApicall(false);
                return false;
            } else {
                setErrors([]);
                setUserid(res.data.data.square_id);
                setuser_id(res.data.data._id);
                history.push(`/remote_fitting?userid=${res.data.data.square_id}`);
                setApicall(false);
                return true;
            }

        } catch (error) {
            setApicall(false);
            console.log("error", error);
        }
    }


    const updateuserdata = async () => {
        try {
            setApicall(true);
            const data = {
                _id: user_id,
                email: formData.email,
                square_id: square_id,
                firstname: formData.firstname,
                lastname: formData.lastname,
                phone: formData.phone,
                height_ft: formData.height_ft,
                height_in: formData.height_in,
                dexterity: formData.dexterity,
            }
            const res = await updateUserremotefitting(data);
            if (!res.data.status) {
                setErrors(res.data.error);
                setApicall(false);
                return false;
            } else {
                setErrors([]);
                setApicall(false);
                return true;
            }

        } catch (error) {
            setApicall(false);
            console.log("error", error);
        }
    }


    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    const handleResize = () => {
        setWidth(window.innerWidth);

        // Get all divs with the class name 'drop_box'
        const squareDivs = document.querySelectorAll('.drop_box');

        squareDivs.forEach((squareDiv) => {
            // Get the width of each div
            const divWidth = squareDiv.offsetWidth;
            setHeight(divWidth); // Assuming setHeight is a valid function in your context

            // Set the height to match the width (making it square)
            squareDiv.style.height = divWidth + 'px';
        });
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);


    // window.addEventListener('load', function () {
    //     // setWidth(window.innerWidth);

    //     // Get all divs with the class name 'drop_box'
    //     const squareDivs = document.querySelectorAll('.drop-box-camera');
    //     console.log('drop-box-camera', squareDivs);

    //     squareDivs.forEach((squareDiv) => {
    //         // Get the width of each div
    //         const divWidth = squareDiv.offsetWidth;
    //         setHeight(divWidth); // Assuming setHeight is a valid function in your context

    //         // Set the height to match the width (making it square)
    //         squareDiv.style.height = divWidth + 'px';
    //         console.log('Div width:', divWidth);
    //     });
    // });

    const [isMobile, setIsMobile] = useState(true);

    // Check if the screen width is less than or equal to 768px (mobile size)
    const checkDevice = () => {
        setIsMobile(window.innerWidth <= 500); // You can adjust the width value as per your needs
    };

    useEffect(() => {
        checkDevice();
        window.addEventListener("resize", checkDevice);
        return () => {
            window.removeEventListener("resize", checkDevice);
        };
    }, []);


    return (
        <>
            {isMobile ? (
                <>
                    <ReactNotifications />
                    <Modal
                        show={show02}
                        onHide={handleClose02}
                        centered
                        id="success_tic"
                        className='model-thank-you'
                    >
                        <Modal.Body>
                            <div className="custom-modal-header">
                                <div className="logo-modal">
                                    <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                                </div>
                                <div className="close-modal">
                                    <button type="button" className="btn-close" onClick={handleClose02} aria-label="Close"> <IoClose /></button>
                                </div>
                            </div>
                            <div className='modal-image'>
                                <img src={require('../../assets/images/forewardFormSubmitClubOrder.png')} alt="logo" />
                            </div>
                            <h3 className="text-center mb-4">
                                Your Fitting is added
                            </h3>
                        </Modal.Body>
                    </Modal>

                    <Modal
                        show={show03}
                        onHide={handleClose03}
                        centered
                        id="success_tic"
                        className='model-thank-you'
                    >
                        <Modal.Body>
                            <h2 className="text-center mb-3">
                                You missed something!
                            </h2>
                            <p className="text-center mb-4">
                                Please fill out every input field in this section before moving on to the next section.
                            </p>

                            <button type="button" className="btn btn-modal-view" onClick={handleClose03}>
                                OK, got it!
                            </button>
                        </Modal.Body>
                    </Modal>

                    <div className="main-page-body-content-header">
                        <Header />
                    </div>
                    <div className="dashboard-container d-flex camera-drop-box-fitting">
                        <div className="main-container">
                            <div className="main-page-body-content">
                                <div className="main-page-body-content-body">
                                    <div className="main-page-body-content-body-container">
                                        <div className="container-fluid">
                                            <div>
                                                <div className="step-btn">
                                                    <div className="step-btn-item">
                                                        <button
                                                            className="btn step-btn-view step-left-btn"
                                                            onClick={handlePrevStep}
                                                            disabled={currentStep === 1}
                                                        >
                                                            {currentStep !== 1 && <FaChevronLeft />}
                                                            <div className="pr_content m-0 step_pr_content">
                                                                <h6>Step {currentStep - +1}</h6>
                                                                <h4>{currentStepName()}</h4>
                                                            </div>
                                                        </button>
                                                    </div>
                                                    <div className="step-btn-item">
                                                        {currentStep === 1 && apicall ? (
                                                            <button
                                                                className="btn step-btn-view step-right-btn"
                                                            >
                                                                <Spinner animation="border" className="border-white" />
                                                            </button>

                                                        ) : (
                                                            <button
                                                                className="btn step-btn-view step-right-btn"
                                                                onClick={handleNextStep}
                                                                disabled={currentStep === 10}
                                                            >
                                                                <div className="pr_content m-0 step_pr_content text-right">
                                                                    <h6>Step {currentStep + 1}</h6>
                                                                    <h4>{nextStepName()}</h4>
                                                                </div>
                                                                {currentStep !== 10 && <FaChevronRight />}
                                                            </button>
                                                        )}

                                                        {/* <button
                                                    className="btn step-btn-view step-right-btn"
                                                    onClick={handleNextStep}
                                                    disabled={currentStep === 9}
                                                >
                                                    <div className="pr_content m-0 step_pr_content text-right">
                                                        <h6>Step {currentStep + 1}</h6>
                                                        <h4>{nextStepName()}</h4>
                                                    </div>
                                                    {currentStep !== 9 && <FaChevronRight />}
                                                </button> */}
                                                    </div>
                                                </div>
                                                <div className="step-content">{renderStepContent()}</div>
                                                <div className="step-btn">
                                                    <div className="step-btn-item">
                                                        <button
                                                            className="btn step-btn-view step-left-btn"
                                                            onClick={handlePrevStep}
                                                            disabled={currentStep === 1}
                                                        >
                                                            {currentStep !== 1 && <FaChevronLeft />}
                                                            <div className="pr_content m-0 step_pr_content">
                                                                <h6>Step {currentStep - +1}</h6>
                                                                <h4>{currentStepName()}</h4>
                                                            </div>
                                                        </button>
                                                    </div>
                                                    <div className="step-btn-item">
                                                        {currentStep === 1 && apicall ? (
                                                            <button
                                                                className="btn step-btn-view step-right-btn"
                                                            >
                                                                <Spinner animation="border" className="border-white" />
                                                            </button>

                                                        ) : (
                                                            <button
                                                                className="btn step-btn-view step-right-btn"
                                                                onClick={handleNextStep}
                                                                disabled={currentStep === 10}
                                                            >
                                                                <div className="pr_content m-0 step_pr_content text-right">
                                                                    <h6>Step {currentStep + 1}</h6>
                                                                    <h4>{nextStepName()}</h4>
                                                                </div>
                                                                {currentStep !== 10 && <FaChevronRight />}
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div style={errorStyle}>
                    This app is only available on mobile devices.
                </div>
            )}
        </>
    );
}

const errorStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    textAlign: 'center',
    backgroundColor: '#98ea24',
    color: '#000000',
    padding: '20px',
    fontSize: '25px',
    fontWeight: 600
};
export default ForewardFitting4;


